<template>
    <div class="main">
        <div class="content">
            <h2 style="margin-bottom: 50px;">海藻电影</h2>
            <van-field
                v-model="phone"
                required
                label="手机号"
                placeholder="请输入手机号"
            />
            <van-field
                v-model="captcha" 
                center
                clearable
                placeholder="请输入验证码"
                required
                label="验证码"
            >
                <template #button>
                    <van-button style="width: 80px" :disabled="btnDisable" @click="fetchCaptcha(phone)" size="small" type="primary">{{ btnStr }}</van-button>
                </template>
            </van-field>
            <van-button style="margin-top: 24px" block @click="checkCaptcha(phone, captcha)" size="normal" type="primary">登录</van-button>
        </div>
    </div> 
</template>

<script>
import {Button, Image, Row, Col, Field} from "vant";
import request from "@/utils/request.js";
import vue from '@/main.js';

export default {
    name: "MovieLogin",
    components: {
        [Button.name]: Button,
        [Image.name]: Image,
        [Row.name]: Row,
        [Col.name]: Col,
        [Field.name]: Field
    },
    data() {
        return {
            phone: undefined,
            captcha: undefined,
            btnDisable: false,
            btnStr: "发送验证码"
        };
    },
    async mounted() {
        const movieSession = vue.$cookies.get("Movie-Session");
        if (movieSession) {
            let url = `https://xzyy.hijin.vip/newfilm/#/pages/movie/movie?platform=${movieSession}`;
            window.location = url;
        }
    },
    methods: {
        async checkCaptcha(phone, captcha) {
            if (!phone || ! captcha) {
                this.$notify({message: '请输入验证码', type: 'warning'});
            }
            let spm = Buffer.from(phone).toString('base64')
            await request.get(`/movie/sms/captcha/check?spm=${spm}&captcha=${captcha}`);
            var timestamp = (new Date().getTime() / 1000).toFixed(0);
            let decryptedStr = `channelCode=6mxZvPN3JHH&mobile=${phone}&time=${timestamp}`;
            let encryptedStr = Buffer.from(decryptedStr).toString('base64');
            let url = `https://xzyy.hijin.vip/newfilm/#/pages/movie/movie?platform=${encryptedStr}`;
            vue.$cookies.set("Movie-Session", encryptedStr);
            window.location = url;
        },
        async fetchCaptcha(phone) {
            if (!phone) {
                this.$notify({message: '手机号不能为空', type: 'warning'});
                return;
            }
            let spm = Buffer.from(phone).toString('base64')
            console.log(spm);
            
            await request.get(`/movie/sms/captcha/fetch?spm=${spm}`);
            this.btnStr = 60;
            this.btnDisable = true;
            var intervalId;
            intervalId = setInterval(() => {
                if (this.btnStr == 55) {
                    this.btnStr = "发送验证码";
                    this.btnDisable = false;
                    clearInterval(intervalId);
                    return;
                }
                this.btnStr -= 1;
            }, 1000);
        }
    }
}
</script>

<style lang="less">
@color-vice: #f0d4c0;
@color-vice-font: #ffdfc3;
@color-vice-weight: #4d3933;

@color-theme: #17161c;
@color-border:#00000026;
@font-size-title: 16px;
@font-weight-title: 500;
@line-height-title: 24px;
@font-color-title: #000000d9;

@font-size-normal: 14px;
@font-weight-normal: 400;
@line-height-normal: 22px;
@font-color-normal: #000000a6;


.content {
    padding-top: 25vh;
    text-align: center;
    height: 100vh;
    background-color: rgb(253, 245, 234);
    padding: 25vh 32px 0 32px;
}


</style>